import LazyLoad from 'vanilla-lazyload';

export default new class ProductSet {
  constructor() {
    this.tabBtnSelector = 'product-set__tab';
    this.tabActiveBtnSelector = 'product-set__tab_active';

    this.changeTab();
  }

  changeTab() {
    const btns = document.querySelectorAll(`.${this.tabBtnSelector}`);

    if (!btns) return;

    [...btns].forEach(el => el.addEventListener('click', () => {
      this.sliderTabHandler(el);
    }));
  }

  sliderTabHandler(el) {
    if (el.matches(`.${this.tabActiveBtnSelector}`)) return;

    this.changeActiveTab(el);
  }

  changeActiveTab(node) {
    const btn = document.querySelectorAll(`.${this.tabBtnSelector}`);

    [...btn].forEach(el => el.classList.remove(this.tabActiveBtnSelector));

    node.classList.add(this.tabActiveBtnSelector);
  }
}();

const opacityPromise = 0.6;

window.productSetInit = (id) => {
  const elementId = `product-set-container-${id}`;
  document.querySelector('.product-set div').id = elementId;

  const container = document.querySelector(`#${elementId}`);
  container.style.opacity = opacityPromise;
}

window.productSetSuccess = (id) => {
  const elementId = `product-set-container-${id}`;
  const container = document.querySelector(`#${elementId}`);
  new LazyLoad();
  container.style.opacity = 1.0;
}

/*
const container = document.querySelector(`#product-set-container`);

const opacityPromise = 0.6;
const promiseHandlers = [
    'onTab',
    'onPaginate',
];

addEventListener('ajax:promise', (e) => {
    const { context } = e.detail;

    productsPromise( context.handler );
});

container.addEventListener('ajax:update', () => {
    productsSuccess();
});  

const productsPromise = (handler) => {
    if( promiseHandlers.includes(handler) ) {
        container.style.opacity = opacityPromise;
    } 
}

const productsSuccess = () => {
    // add listeners to inputs
    container.style.opacity = 1.0;
    new LazyLoad();
}
*/
